import React, { useEffect } from 'react';
import {
  Box,
  HeadingText,
  GDSStyleObject,
  StackLayout,
  UtilityText,
  ParagraphText,
} from '@leagueplatform/genesis-core';

export function FormInstructions(props: any) {
  const { footerToBottom } = props;

  const instructionsList = [
    '1. Use a separate claim form for each patient.',
    '2. Enter full name, address and zip code when a name and address field is required.',
    '3. Attach any receipts, bills or supporting claim documentation you may have received from your dentist. You will not be able to submit the form without these attachments.',
    '4. All fields are required unless listed as optional.',
  ];

  useEffect(() => {
    footerToBottom(false);
  }, [footerToBottom]);

  return (
    <StackLayout
      css={
        {
          backgroundColor: 'White',
          maxWidth: '800px',
          float: 'left',
        } as GDSStyleObject
      }
      horizontalAlignment="center"
    >
      <Box
        css={
          {
            display: 'flex',
            flexDirection: 'column',
            padding: '$three $two $two $two',
          } as GDSStyleObject
        }
      >
        <Box
          css={
            {
              display: 'flex',
              flexDirection: 'column',
              padding: '$none $two',
            } as GDSStyleObject
          }
        >
          <HeadingText
            data-testid="formInsTitle"
            level="1"
            size={{
              '@initial': 'xxl',
              '@mobile': 'xl',
              '@mobileLandscape': 'xl',
              '@tablet': 'xl',
              '@laptop': 'xxl',
              '@desktop': 'xxl',
            }}
          >
            Member Dental Claim Form
          </HeadingText>
        </Box>

        <Box
          css={
            {
              display: 'flex',
              flexDirection: 'column',
              padding: '$one $none',
              width: '100%',
            } as GDSStyleObject
          }
        >
          <Box
            css={
              {
                backgroundColor: '#F8F8F8',
                padding: '$one $two',
              } as GDSStyleObject
            }
          >
            <HeadingText
              level="3"
              size={{
                '@initial': 'xl',
                '@mobile': 'lg',
                '@mobileLandscape': 'lg',
                '@tablet': 'xl',
                '@laptop': 'xl',
                '@desktop': 'xl',
              }}
            >
              Form Instructions:
            </HeadingText>
            <Box
              css={
                {
                  marginTop: '$one',
                  padding: '$none $one',
                } as GDSStyleObject
              }
            >
              <UtilityText>
                <ol>
                  {instructionsList.map((inst: any) => (
                    <li key={inst}>{inst}</li>
                  ))}
                </ol>
              </UtilityText>
            </Box>
            <Box
              css={
                {
                  marginTop: '$one',
                  padding: '$none $one',
                } as GDSStyleObject
              }
            >
              <UtilityText>
                <ul style={{ listStyle: 'disc' }}>
                  Itemized bill must include:
                  <ParagraphText
                    css={
                      {
                        marginTop: '$half',
                        marginLeft: '$oneAndHalf',
                      } as GDSStyleObject
                    }
                  >
                    <li>
                      Provider’s name and address (on provider’s stationary)
                    </li>
                  </ParagraphText>
                  <ParagraphText
                    css={
                      {
                        marginTop: '$half',
                        marginLeft: '$oneAndHalf',
                      } as GDSStyleObject
                    }
                  >
                    <li>Patient’s full name (no nicknames)</li>
                  </ParagraphText>
                  <ParagraphText
                    css={
                      {
                        marginTop: '$half',
                        marginLeft: '$oneAndHalf',
                      } as GDSStyleObject
                    }
                  >
                    <li>Type of service(s)</li>
                  </ParagraphText>
                  <ParagraphText
                    css={
                      {
                        marginTop: '$half',
                        marginLeft: '$oneAndHalf',
                      } as GDSStyleObject
                    }
                  >
                    <li>Date of each service, supply or purchase</li>
                  </ParagraphText>
                  <ParagraphText
                    css={
                      {
                        marginTop: '$half',
                        marginLeft: '$oneAndHalf',
                      } as GDSStyleObject
                    }
                  >
                    <li>Charge</li>
                  </ParagraphText>
                </ul>
              </UtilityText>
            </Box>
            <Box
              css={
                {
                  marginTop: '$one',
                  padding: '$none $one',
                } as GDSStyleObject
              }
            >
              <UtilityText>
                Note: Cancelled checks, cash register receipts and personal
                itemizations are not acceptable as itemized bills.
              </UtilityText>
            </Box>
          </Box>
        </Box>
      </Box>
    </StackLayout>
  );
}
